import { MarketCountryCode } from '@backmarket/http-api'

export const COUNTRIES_WITHOUT_VAT_TEXT = [MarketCountryCode.JP]
